export default __webpack_public_path__ + "static/media/IMG-20230628-WA0052.9f23deca.jpg";